module.exports = __webpack_public_path__ + "static/bg3-a6dc4711abec92c42eb84a83f542b018.jpeg";